<template>
  <div id="app" :class="`page-${$route.name}`">
    <Menu />
    <div class="wrapper">
      <div class="container">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
        </keep-alive>
        <!-- :key="$route.fullPath 解决连续点击同一vue页面不同传值不刷新的问题 -->
        <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '../components/layout/menu.vue';

export default {
  components: {
    Menu,
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
#app > .wrapper {
  padding-top: $topbar-nav-height + 10px;
  padding-left: 180px;
  padding-bottom: 15px;
  & > .container {
    width: $container-width;
    margin: 0 auto;
  }
}
</style>
